import { useEffect } from "react";
import { apiClient } from "../lib/apiClient";
import { useAuthStore } from "../store/auth";

export const useBootstrapAuth = () => {
  const setAgent = useAuthStore((state) => state.setAgent);
  const setStatus = useAuthStore((state) => state.setStatus);
  const status = useAuthStore((state) => state.status);

  useEffect(() => {
    let mounted = true;
    const bootstrap = async () => {
      if (status !== "idle") return;
      setStatus("loading");
      try {
        const response = await apiClient.get<{ agent: any }>("/auth/me");
        if (!mounted) return;
        if (response.data.agent) {
          setAgent(response.data.agent);
        } else {
          setStatus("unauthenticated");
        }
      } catch {
        if (mounted) {
          setStatus("unauthenticated");
        }
      }
    };

    bootstrap();
    return () => {
      mounted = false;
    };
  }, [setAgent, setStatus, status]);
};
